























































































































































































































import { Component, Vue } from "vue-property-decorator";
import questionAdd from "./questionAdd.vue";
import questionGroup from "./questionGroup.vue";
import questionItem from "./questionItem.vue";
import questionPreview from "./questionPreview.vue";
import questionRule from "./questionRule.vue";
import { getQuestionTypeAllList, QuestionTypeForm } from "@/serve/question/questionType";
import {
  addQuestion,
  copyQuestion,
  copyQuestionItem,
  deleteQuestion,
  deleteQuestionItem,
  disableQuestion,
  enableQuestion,
  getNextItemCode,
  getQuestionDetail,
  getQuestionItems,
  getQuestionList,
  previewQuestion,
  QuestionCopyForm,
  QuestionForm,
  QuestionItemForm,
  QuestionOptionForm,
  QuestionPreview,
  sortQuestionItems,
  saveQuestionItem,
  updateQuestion,
  uploadQuestionImg
} from "@/serve/question/question";
import {
  addQuestionRule,
  copyQuestionRule,
  deleteQuestionGroup,
  deleteQuestionRule,
  getQuestionGroupItemList,
  getQuestionGroupList,
  getQuestionResultList,
  getQuestionRuleList,
  QuestionGroupForm,
  QuestionGroupItemForm,
  QuestionResultForm,
  QuestionRuleForm,
  saveQuestionGroupDetail,
  updateQuestionRule
} from "@/serve/question/questionConfig";
interface QuestionQuery {
  current: number;
  size: number;
  questionCode: string;
  questionName: string;
  typeId: number | null;
  status: number | null;
}

@Component({
  name: "questionEdit",
  components: {
    questionAdd,
    questionGroup,
    questionItem,
    questionPreview,
    questionRule
  }
})
export default class QuestionEdit extends Vue {
  public form: QuestionQuery = {
    current: 1,
    size: 10,
    questionCode: "",
    questionName: "",
    typeId: null,
    status: null
  };

  public typeList: QuestionTypeForm[] = [];
  public tableData: QuestionForm[] = [];
  public total = 0;
  public loading = false;
  public submitLoading = false;
  public questionDialog = false;
  public isAddQuestion = true;
  public questionForm: QuestionForm = this.emptyQuestionForm();
  public copyDialog = false;
  public copyForm: QuestionCopyForm = { id: 0, questionCode: "", questionName: "" };

  public editMode = true;
  public editingQuestion: QuestionForm = this.emptyQuestionForm();
  public itemKeyword = "";
  public itemList: QuestionItemForm[] = [];
  public parentItemList: QuestionItemForm[] = [];
  public itemLoading = false;
  public itemDialog = false;
  public isAddItem = true;
  public itemForm: QuestionItemForm = this.emptyItemForm();
  public quickOptionText = "";
  private dragStartIndex = -1;
  private optionDragStartIndex = -1;

  public previewDialog = false;
  public groupDialog = false;
  public ruleDialog = false;
  public groupActiveTab = "group";
  public groupList: QuestionGroupForm[] = [];
  public groupItemList: QuestionGroupItemForm[] = [];
  public resultList: QuestionResultForm[] = [];
  public selectedGroupId: number | null = null;
  public groupLoading = false;
  public groupItemLoading = false;
  public resultLoading = false;
  public groupFormDialog = false;
  public isAddGroup = true;
  public groupForm: QuestionGroupForm = this.emptyGroupForm();
  public selectedGroupItemIds: number[] = [];
  public groupResultList: QuestionResultForm[] = [];
  public groupItemFormDialog = false;
  public isAddGroupItem = true;
  public groupItemForm: QuestionGroupItemForm = this.emptyGroupItemForm();
  public resultFormDialog = false;
  public isAddResult = true;
  public resultForm: QuestionResultForm = this.emptyResultForm();
  public ruleList: QuestionRuleForm[] = [];
  public ruleLoading = false;
  public ruleFormDialog = false;
  public isAddRule = true;
  public ruleForm: QuestionRuleForm = this.emptyRuleForm();
  public previewData: QuestionPreview = {
    question: this.emptyQuestionForm(),
    items: []
  };

  public get questionDialogTitle() {
    return this.isAddQuestion ? "新增问卷" : "修改问卷";
  }

  public get itemDialogTitle() {
    return this.isAddItem ? "新增题目" : "编辑题目";
  }

  public get groupDialogTitle() {
    return this.isAddGroup ? "新增分组" : "编辑分组";
  }

  public get groupItemDialogTitle() {
    return this.isAddGroupItem ? "新增分组题目" : "编辑分组题目";
  }

  public get resultDialogTitle() {
    return this.isAddResult ? "新增结论" : "编辑结论";
  }

  public get ruleDialogTitle() {
    return this.isAddRule ? "新增规则" : "编辑规则";
  }

  public get parentItemOptions() {
    const currentId = this.itemForm && this.itemForm.id;
    const excludeIds = new Set<number>();
    if (currentId) {
      excludeIds.add(currentId);
      this.getDescendantItemIds(currentId, this.parentItemList).forEach(id => excludeIds.add(id));
    }
    return (this.parentItemList || []).filter(item => {
      return item.id && !excludeIds.has(item.id);
    });
  }

  public get hasParentItem() {
    return this.normalizeParentItemId(this.itemForm.parentItemId) !== null;
  }

  public created() {
    this.getTypeList();
    this.loadQuestion();
  }

  private emptyQuestionForm(): QuestionForm {
    return {
      id: null,
      questionCode: "",
      questionName: "",
      typeId: null,
      description: "",
      status: 0,
      sort: 0,
      scoreEnabled: 0,
      scoreMethod: "none"
    };
  }

  private emptyItemForm(): QuestionItemForm {
    const editingQuestion = this.editingQuestion || ({} as QuestionForm);
    const itemList = this.itemList || [];
    return {
      id: null,
      questionId: editingQuestion.id || null,
      itemCode: "",
      itemTitle: "",
      itemDesc: "",
      itemType: "single",
      imgUrl: "",
      parentItemId: null,
      isRequired: 1,
      isShow: 1,
      placeholder: "",
      validationRule: "",
      minSelect: null,
      maxSelect: null,
      scoreEnabled: 0,
      scoreStrategy: "none",
      sort: itemList.length + 1,
      options: [this.newOption(1), this.newOption(2)]
    };
  }

  private newOption(sort: number, label = ""): QuestionOptionForm {
    return {
      id: null,
      itemId: null,
      optionLabel: label,
      optionValue: label,
      optionScore: 0,
      imgUrl: "",
      isInput: 0,
      isExclusive: 0,
      sort
    };
  }

  private emptyGroupForm(): QuestionGroupForm {
    const editingQuestion = this.editingQuestion || ({} as QuestionForm);
    const groupList = this.groupList || [];
    return {
      id: null,
      questionId: editingQuestion.id || null,
      groupCode: "",
      groupName: "",
      groupType: "total",
      description: "",
      scoreMethod: "sum",
      sort: groupList.length + 1
    };
  }

  private emptyGroupItemForm(): QuestionGroupItemForm {
    const groupItemList = this.groupItemList || [];
    return {
      id: null,
      groupId: this.selectedGroupId,
      itemId: null,
      itemWeight: 1,
      sort: groupItemList.length + 1
    };
  }

  private emptyResultForm(): QuestionResultForm {
    const editingQuestion = this.editingQuestion || ({} as QuestionForm);
    const resultList = this.resultList || [];
    return {
      id: null,
      questionId: editingQuestion.id || null,
      groupId: this.selectedGroupId,
      resultCode: "",
      resultName: "",
      resultDesc: "",
      suggestion: "",
      minScore: 0,
      maxScore: null,
      sort: resultList.length + 1
    };
  }

  private emptyRuleForm(): QuestionRuleForm {
    const editingQuestion = this.editingQuestion || ({} as QuestionForm);
    const ruleList = this.ruleList || [];
    return {
      id: null,
      questionId: editingQuestion.id || null,
      sourceType: "inside",
      sourceField: "",
      itemId: null,
      optionId: null,
      conditions: "eq",
      compareValue: "",
      targetItemId: null,
      action: "show",
      description: "",
      status: 1,
      sort: ruleList.length + 1
    };
  }

  public async getTypeList() {
    const res = await getQuestionTypeAllList();
    if (res.success) {
      this.typeList = res.data || [];
    }
  }

  public async loadQuestion() {
    const id = Number(this.$route.query.id);
    if (!id) {
      this.$message.warning("缺少问卷ID");
      this.backToList();
      return;
    }
    const res = await getQuestionDetail(id);
    if (res.success) {
      this.editingQuestion = res.data || this.emptyQuestionForm();
      this.itemKeyword = "";
      this.getItemList();
    } else {
      this.showApiError(res, "问卷不存在");
      this.backToList();
    }
  }

  public search() {
    this.form.current = 1;
    this.getTableData();
  }

  public async getTableData() {
    this.loading = true;
    try {
      const dataItem = { ...this.form };
      const res = await getQuestionList((this as any).$changNull(dataItem));
      if (res.success) {
        this.tableData = res.data.records || [];
        this.total = res.data.total || 0;
      }
    } finally {
      this.loading = false;
    }
  }

  public resetForm() {
    this.form = {
      current: 1,
      size: 10,
      questionCode: "",
      questionName: "",
      typeId: null,
      status: null
    };
    this.getTableData();
  }

  public addNewQuestion() {
    this.isAddQuestion = true;
    this.questionForm = {
      ...this.emptyQuestionForm(),
      sort: this.total + 1
    };
    this.questionDialog = true;
  }

  public editQuestion(row: QuestionForm) {
    this.isAddQuestion = false;
    this.questionForm = {
      ...row,
      scoreMethod: row.scoreMethod || "none"
    };
    this.questionDialog = true;
  }

  public async submitQuestion() {
      this.submitLoading = true;
      try {
        const submitData = { ...this.questionForm };
        if (submitData.scoreEnabled !== 1) {
          submitData.scoreMethod = "none";
        }
        const res = this.isAddQuestion
          ? await addQuestion(submitData)
          : await updateQuestion(submitData);
        if (res.success) {
          this.$message.success(res.msg || "保存成功");
          this.questionDialog = false;
          if (this.editMode && !this.isAddQuestion) {
            this.editingQuestion = {
              ...this.editingQuestion,
              ...submitData
            };
          }
          this.getTableData();
        } else {
          this.showApiMessage(res, "保存失败", "warning");
        }
      } finally {
        this.submitLoading = false;
      }
  }

  public openQuestionEditor(row: QuestionForm) {
    this.editingQuestion = { ...row };
    this.editMode = true;
    this.itemKeyword = "";
    this.getItemList();
  }

  public backToList() {
    const query = { ...this.$route.query };
    delete query.id;
    this.$router.push({
      path: "/questionManage",
      query
    });
  }

  public deleteQuestionRow(row: QuestionForm) {
    (this as any).$messageBox
      .confirm(`您确定要删除问卷【${row.questionName}】吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(async () => {
        const res = await deleteQuestion(row.id as number);
        if (res.success) {
          this.$message.success("删除成功");
          this.getTableData();
        } else {
          this.showApiError(res, "删除失败");
        }
      });
  }

  public async switchChange(row: QuestionForm) {
    const isEnable = row.status === 1;
    const text = isEnable ? "启用" : "停用";
    const res = isEnable
      ? await enableQuestion(row.id as number)
      : await disableQuestion(row.id as number);
    if (res.success) {
      this.$message.success(`${text}成功`);
      this.getTableData();
    } else {
      this.showApiError(res, `${text}失败`);
      this.getTableData();
    }
  }

  public openCopyQuestion(row: QuestionForm) {
    this.copyForm = {
      id: row.id as number,
      questionCode: "",
      questionName: `${row.questionName}-副本`
    };
    this.copyDialog = true;
  }

  public async submitCopyQuestion() {
    this.submitLoading = true;
    try {
      const res = await copyQuestion({
        ...this.copyForm,
        questionCode: this.copyForm.questionCode || undefined,
        questionName: this.copyForm.questionName || undefined
      });
      if (res.success) {
        this.$message.success("复制成功");
        this.copyDialog = false;
        const copied = res.data;
        if (copied && copied.id) {
          this.$router.push({
            path: "/questionManageEdit",
            query: {
              ...this.$route.query,
              id: String(copied.id)
            }
          });
        } else {
          this.getTableData();
        }
      } else {
        this.showApiError(res, "复制失败");
      }
    } finally {
      this.submitLoading = false;
    }
  }

  public async openPreview(id: number) {
    const res = await previewQuestion(id);
    if (res.success) {
      this.previewData = res.data || { question: this.emptyQuestionForm(), items: [] };
      this.previewDialog = true;
    }
  }

  public async getItemList() {
    if (!this.editingQuestion.id) {
      return;
    }
    this.itemLoading = true;
    try {
      const res = await getQuestionItems({
        questionId: this.editingQuestion.id,
        keyword: this.itemKeyword
      });
      if (res.success) {
        this.itemList = this.normalizeItemTreeOrder(res.data || []);
        if (!this.itemKeyword) {
          this.parentItemList = this.itemList.map(item => ({ ...item }));
        }
        this.$nextTick(this.bindItemDrag);
      }
    } finally {
      this.itemLoading = false;
    }
  }

  public resetItemSearch() {
    this.itemKeyword = "";
    this.getItemList();
  }

  public async addNewItem() {
    this.isAddItem = true;
    this.itemForm = this.emptyItemForm();
    await this.loadParentItemList();
    if (this.editingQuestion.id) {
      const res = await getNextItemCode(this.editingQuestion.id);
      if (res.success) {
        this.itemForm.itemCode = res.data || "";
      }
    }
    this.quickOptionText = "";
    this.itemDialog = true;
    this.$nextTick(this.bindOptionDrag);
  }

  public async editItem(row: QuestionItemForm) {
    this.isAddItem = false;
    this.itemForm = {
      ...this.emptyItemForm(),
      ...row,
      questionId: this.editingQuestion.id || row.questionId,
      parentItemId: this.normalizeParentItemId(row.parentItemId),
      options: (row.options || []).map(item => ({
        ...item,
        isInput: item.isInput || 0,
        isExclusive: item.isExclusive || 0
      }))
    };
    if (this.itemForm.itemType !== "text" && this.itemForm.options.length === 0) {
      this.itemForm.options = [this.newOption(1), this.newOption(2)];
    }
    this.quickOptionText = "";
    await this.ensureParentItemList();
    this.itemDialog = true;
    this.$nextTick(this.bindOptionDrag);
  }

  private async ensureParentItemList() {
    if (this.parentItemList && this.parentItemList.length > 0) {
      return;
    }
    if (!this.itemKeyword && this.itemList && this.itemList.length > 0) {
      this.parentItemList = this.itemList.map(item => ({ ...item }));
      return;
    }
    await this.loadParentItemList();
  }

  private invalidateParentItemList() {
    this.parentItemList = [];
  }

  private async loadParentItemList() {
    if (!this.editingQuestion.id) {
      this.parentItemList = [];
      return;
    }
    const res = await getQuestionItems({
      questionId: this.editingQuestion.id,
      keyword: ""
    });
    if (res.success) {
      this.parentItemList = res.data || [];
    }
  }

  public handleParentItemChange(value: number | string | null) {
    const parentItemId = this.normalizeParentItemId(value);
    this.itemForm.parentItemId = parentItemId;
    if (parentItemId !== null) {
      this.itemForm.isShow = 0;
      this.itemForm.isRequired = 0;
    }
  }

  public parentItemLabel(item: QuestionItemForm) {
    return `${item.itemCode || ""} ${item.itemTitle || ""}`.trim();
  }

  public itemTypeLabel(type: string) {
    const map: { [key: string]: string } = {
      single: "单选",
      multiple: "多选",
      text: "填空"
    };
    return map[type] || type;
  }

  public itemLevel(row: QuestionItemForm) {
    let level = 0;
    let parentItemId = this.normalizeParentItemId(row.parentItemId);
    const visited = new Set<number>();
    while (parentItemId !== null && !visited.has(parentItemId)) {
      visited.add(parentItemId);
      const parentItem = this.itemList.find(item => item.id === parentItemId);
      if (!parentItem) {
        break;
      }
      level += 1;
      parentItemId = this.normalizeParentItemId(parentItem.parentItemId);
    }
    return level;
  }

  public async submitItem() {
    if (this.itemForm.itemType !== "text" && this.itemForm.options.length === 0) {
      this.$message.warning("请至少维护一个选项");
      return false;
    }
    this.submitLoading = true;
    try {
      const parentItemId = this.normalizeParentItemId(this.itemForm.parentItemId);
      const submitData = {
        ...this.itemForm,
        parentItemId,
        isRequired: parentItemId ? 0 : this.itemForm.isRequired,
        isShow: parentItemId ? 0 : this.itemForm.isShow,
        options: this.itemForm.itemType === "text" ? [] : this.normalizeOptions()
      };
      const res = await saveQuestionItem(submitData);
      if (res.success) {
        this.$message.success("保存成功");
        this.itemDialog = false;
        this.invalidateParentItemList();
        this.getItemList();
      } else {
        this.showApiError(res, "保存失败");
      }
    } finally {
      this.submitLoading = false;
    }
    return true;
  }

  public copyItem(row: QuestionItemForm) {
    (this as any).$messageBox
      .confirm(`您确定要复制题目【${row.itemTitle}】吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(async () => {
        const res = await copyQuestionItem(row.id as number);
        if (res.success) {
          this.$message.success("复制成功");
          this.invalidateParentItemList();
          await this.getItemList();
          if (res.data) {
            this.editItem(res.data);
          }
        } else {
          this.showApiError(res, "复制失败");
        }
      });
  }

  public deleteItem(row: QuestionItemForm) {
    (this as any).$messageBox
      .confirm(`您确定要删除题目【${row.itemTitle}】吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(async () => {
        const res = await deleteQuestionItem(row.id as number);
        if (res.success) {
          this.$message.success("删除成功");
          this.invalidateParentItemList();
          this.getItemList();
        } else {
          this.showApiError(res, "删除失败");
        }
      });
  }

  public async saveItemSort() {
    if (this.itemKeyword) {
      this.$message.warning("请先清空题目搜索后再保存排序");
      return;
    }
    if (!this.editingQuestion.id) {
      return;
    }
    const res = await sortQuestionItems({
      questionId: this.editingQuestion.id,
      items: this.itemList.map((item, index) => ({
        id: item.id as number,
        sort: index + 1
      }))
    });
    this.invalidateParentItemList();
    if (res.success) {
      this.$message.success("排序保存成功");
      this.getItemList();
    } else {
      this.showApiError(res, "排序保存失败");
      this.getItemList();
    }
  }

  public addOption() {
    this.itemForm.options.push(this.newOption(this.itemForm.options.length + 1));
    this.$nextTick(this.bindOptionDrag);
  }

  public removeOption(index: number) {
    this.itemForm.options.splice(index, 1);
    this.resetOptionSort();
    this.$nextTick(this.bindOptionDrag);
  }

  public handleItemTypeChange() {
    if (this.itemForm.itemType !== "text" && this.itemForm.options.length === 0) {
      this.itemForm.options = [this.newOption(1), this.newOption(2)];
    }
    this.$nextTick(this.bindOptionDrag);
  }

  public quickGenerateOptions() {
    const list = this.quickOptionText
      .split("|")
      .map(item => item.trim())
      .filter(item => item);
    if (list.length === 0) {
      this.$message.warning("请输入需要生成的选项内容");
      return;
    }
    this.itemForm.options = list.map((label, index) => this.newOption(index + 1, label));
    this.$nextTick(this.bindOptionDrag);
  }

  public async uploadItemImage(res: { file: File }) {
    const data = new FormData();
    data.append("file", res.file);
    const file = await uploadQuestionImg(data);
    if (file.success) {
      this.$set(this.itemForm, "imgUrl", file.data || "");
      this.$message.success("题目图片上传成功");
    } else {
      this.showApiError(file, "题目图片上传失败");
    }
  }

  public uploadOptionImage(option: QuestionOptionForm) {
    return async (res: { file: File }) => {
      const data = new FormData();
      data.append("file", res.file);
      const file = await uploadQuestionImg(data);
      if (file.success) {
        this.$set(option, "imgUrl", file.data || "");
        this.$message.success("选项图片上传成功");
      } else {
        this.showApiError(file, "选项图片上传失败");
      }
    };
  }

  public beforeImageUpload(file: { type: string; size: number }) {
    const isJPG = file.type === "image/jpeg";
    const isPNG = file.type === "image/png";
    const isPG = isJPG || isPNG;
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isPG) {
      this.$message.error("上传图片只能是 JPG/PNG 格式");
    }
    if (!isLt2M) {
      this.$message.error("上传图片大小不能超过 2MB");
    }
    return isPG && isLt2M;
  }

  private normalizeOptions(): QuestionOptionForm[] {
    return this.itemForm.options.map((option, index) => ({
      ...option,
      optionLabel: option.optionLabel ? option.optionLabel.trim() : "",
      optionValue: option.optionValue || option.optionLabel,
      optionScore: option.optionScore === undefined ? 0 : option.optionScore,
      isInput: option.isInput || 0,
      isExclusive: option.isExclusive || 0,
      sort: index + 1
    }));
  }

  private resetOptionSort() {
    this.itemForm.options = this.itemForm.options.map((option, index) => ({
      ...option,
      sort: index + 1
    }));
  }

  private normalizeParentItemId(value: number | string | null | undefined) {
    if (value === null || value === undefined || value === "") {
      return null;
    }
    const id = Number(value);
    return id > 0 ? id : null;
  }

  private normalizeItemTreeOrder(items: QuestionItemForm[]) {
    const idSet = new Set<number>();
    items.forEach(item => {
      if (item.id) {
        idSet.add(item.id);
      }
    });

    const childrenMap = new Map<number | null, QuestionItemForm[]>();
    items.forEach(item => {
      const parentItemId = this.normalizeParentItemId(item.parentItemId);
      const key = parentItemId !== null && idSet.has(parentItemId) ? parentItemId : null;
      if (!childrenMap.has(key)) {
        childrenMap.set(key, []);
      }
      (childrenMap.get(key) as QuestionItemForm[]).push(item);
    });

    childrenMap.forEach(list => {
      list.sort((a, b) => {
        const sortA = a.sort || 0;
        const sortB = b.sort || 0;
        if (sortA !== sortB) {
          return sortA - sortB;
        }
        return (a.id || 0) - (b.id || 0);
      });
    });

    const result: QuestionItemForm[] = [];
    const visited = new Set<number>();
    const appendChildren = (parentId: number | null) => {
      const children = childrenMap.get(parentId) || [];
      children.forEach(item => {
        if (item.id && visited.has(item.id)) {
          return;
        }
        if (item.id) {
          visited.add(item.id);
        }
        result.push(item);
        if (item.id) {
          appendChildren(item.id);
        }
      });
    };

    appendChildren(null);
    items.forEach(item => {
      if (!item.id || !visited.has(item.id)) {
        result.push(item);
      }
    });

    return result;
  }

  private getDescendantItemIds(itemId: number, items: QuestionItemForm[]) {
    const descendantIds = new Set<number>();
    let changed = true;
    while (changed) {
      changed = false;
      items.forEach(item => {
        if (!item.id || descendantIds.has(item.id)) {
          return;
        }
        const parentItemId = this.normalizeParentItemId(item.parentItemId);
        if (parentItemId === itemId || (parentItemId !== null && descendantIds.has(parentItemId))) {
          descendantIds.add(item.id);
          changed = true;
        }
      });
    }
    return descendantIds;
  }

  private getItemSubtreeRange(list: QuestionItemForm[], startIndex: number) {
    const rootItem = list[startIndex];
    if (!rootItem || !rootItem.id) {
      return { start: startIndex, end: startIndex };
    }
    const descendantIds = this.getDescendantItemIds(rootItem.id, list);
    let end = startIndex;
    for (let index = startIndex + 1; index < list.length; index += 1) {
      const item = list[index];
      if (!item.id || !descendantIds.has(item.id)) {
        break;
      }
      end = index;
    }
    return { start: startIndex, end };
  }

  public bindOptionDrag() {
    const table = this.$el.querySelector(
      ".question-option-table .el-table__body-wrapper tbody"
    ) as HTMLElement;
    if (!table) {
      return;
    }
    const rows = table.querySelectorAll("tr");
    rows.forEach((row, index) => {
      row.setAttribute("draggable", "true");
      row.setAttribute("data-index", String(index));
      row.removeEventListener("dragstart", this.handleOptionDragStart as EventListener);
      row.removeEventListener("dragover", this.handleOptionDragOver as EventListener);
      row.removeEventListener("drop", this.handleOptionDrop as EventListener);
      row.addEventListener("dragstart", this.handleOptionDragStart as EventListener);
      row.addEventListener("dragover", this.handleOptionDragOver as EventListener);
      row.addEventListener("drop", this.handleOptionDrop as EventListener);
    });
  }

  private handleOptionDragStart(event: DragEvent) {
    const target = event.currentTarget as HTMLElement;
    this.optionDragStartIndex = Number(target.dataset.index);
  }

  private handleOptionDragOver(event: DragEvent) {
    event.preventDefault();
  }

  private handleOptionDrop(event: DragEvent) {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    const dropIndex = Number(target.dataset.index);
    if (this.optionDragStartIndex < 0 || this.optionDragStartIndex === dropIndex) {
      return;
    }
    const list = [...this.itemForm.options];
    const dragItem = list.splice(this.optionDragStartIndex, 1)[0];
    list.splice(dropIndex, 0, dragItem);
    this.itemForm.options = list.map((option, index) => ({
      ...option,
      sort: index + 1
    }));
    this.optionDragStartIndex = -1;
    this.$nextTick(this.bindOptionDrag);
  }

  public bindItemDrag() {
    const table = this.$el.querySelector(
      ".question-item-table .el-table__body-wrapper tbody"
    ) as HTMLElement;
    if (!table) {
      return;
    }
    const rows = table.querySelectorAll("tr");
    rows.forEach((row, index) => {
      row.setAttribute("draggable", this.itemKeyword ? "false" : "true");
      row.setAttribute("data-index", String(index));
      row.removeEventListener("dragstart", this.handleDragStart as EventListener);
      row.removeEventListener("dragover", this.handleDragOver as EventListener);
      row.removeEventListener("drop", this.handleDrop as EventListener);
      row.addEventListener("dragstart", this.handleDragStart as EventListener);
      row.addEventListener("dragover", this.handleDragOver as EventListener);
      row.addEventListener("drop", this.handleDrop as EventListener);
    });
  }

  private handleDragStart(event: DragEvent) {
    const target = event.currentTarget as HTMLElement;
    this.dragStartIndex = Number(target.dataset.index);
  }

  private handleDragOver(event: DragEvent) {
    event.preventDefault();
  }

  private handleDrop(event: DragEvent) {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    const dropIndex = Number(target.dataset.index);
    if (this.dragStartIndex < 0 || this.dragStartIndex === dropIndex) {
      return;
    }
    const sourceItem = this.itemList[this.dragStartIndex];
    const targetItem = this.itemList[dropIndex];
    if (!sourceItem || !targetItem) {
      this.dragStartIndex = -1;
      return;
    }
    const sourceParentId = this.normalizeParentItemId(sourceItem.parentItemId);
    const targetParentId = this.normalizeParentItemId(targetItem.parentItemId);
    if (sourceParentId !== targetParentId) {
      this.$message.warning("只允许同级题目之间拖动排序");
      this.dragStartIndex = -1;
      this.$nextTick(this.bindItemDrag);
      return;
    }
    const list = [...this.itemList];
    const range = this.getItemSubtreeRange(list, this.dragStartIndex);
    if (dropIndex >= range.start && dropIndex <= range.end) {
      this.dragStartIndex = -1;
      this.$nextTick(this.bindItemDrag);
      return;
    }
    const targetRange = this.getItemSubtreeRange(list, dropIndex);
    const insertIndex = this.dragStartIndex < dropIndex ? targetRange.end + 1 : dropIndex;
    const movingItems = list.splice(range.start, range.end - range.start + 1);
    const adjustedDropIndex = insertIndex > range.start
      ? insertIndex - movingItems.length
      : insertIndex;
    list.splice(adjustedDropIndex, 0, ...movingItems);
    if (!this.checkItemParentSort(list)) {
      this.$message.warning("子题不能排到上级题目前面");
      this.dragStartIndex = -1;
      this.$nextTick(this.bindItemDrag);
      return;
    }
    const sortedList = list.map((item, index) => ({
      ...item,
      sort: index + 1
    }));
    this.itemList = this.normalizeItemTreeOrder(sortedList);
    this.dragStartIndex = -1;
    this.$nextTick(this.bindItemDrag);
    this.saveItemSort();
  }

  private checkItemParentSort(list: QuestionItemForm[]) {
    const indexMap = new Map<number, number>();
    list.forEach((item, index) => {
      if (item.id) {
        indexMap.set(item.id, index);
      }
    });
    return list.every((item, index) => {
      const parentItemId = this.normalizeParentItemId(item.parentItemId);
      if (parentItemId === null || !indexMap.has(parentItemId)) {
        return true;
      }
      return index > (indexMap.get(parentItemId) as number);
    });
  }

  public async openGroupDialog() {
    if (!this.editingQuestion.id) {
      this.$message.warning("缺少问卷ID");
      return;
    }
    this.groupActiveTab = "group";
    await this.loadGroupManageData();
    this.groupDialog = true;
  }

  public async openRuleDialog() {
    if (!this.editingQuestion.id) {
      this.$message.warning("缺少问卷ID");
      return;
    }
    await this.loadRules();
    this.ruleDialog = true;
  }

  private async loadGroupManageData() {
    try {
      await this.loadGroups();
    } catch (error) {
      this.$message.error("分组数据加载失败");
    }
  }

  public async loadGroups() {
    if (!this.editingQuestion.id) {
      return;
    }
    this.groupLoading = true;
    try {
      const res = await getQuestionGroupList({ current: 1, size: 500, questionId: this.editingQuestion.id });
      if (res.success) {
        this.groupList = (res.data && res.data.records) || [];
        if (!this.selectedGroupId && this.groupList.length > 0) {
          this.selectedGroupId = this.groupList[0].id as number;
        }
        if (this.selectedGroupId && !this.groupList.some(item => item.id === this.selectedGroupId)) {
          this.selectedGroupId = this.groupList.length > 0 ? this.groupList[0].id as number : null;
        }
      }
    } finally {
      this.groupLoading = false;
    }
  }

  public addGroupRow() {
    this.isAddGroup = true;
    this.groupForm = this.emptyGroupForm();
    this.selectedGroupItemIds = [];
    this.groupResultList = [this.emptyResultForm()];
    this.groupFormDialog = true;
  }

  public async editGroupRow(row: QuestionGroupForm) {
    this.isAddGroup = false;
    this.groupForm = { ...this.emptyGroupForm(), ...row };
    await Promise.all([
      this.loadGroupItemIds(row.id as number),
      this.loadGroupResults(row.id as number)
    ]);
    this.groupFormDialog = true;
  }

  public submitGroup(formRef: any) {
    formRef.validate(async (valid: boolean) => {
      if (!valid || !this.editingQuestion.id) {
        return;
      }
      if (this.groupForm.groupType === "part" && this.selectedGroupItemIds.length === 0) {
        this.$message.warning("请选择对应题目后再保存");
        return;
      }
      this.submitLoading = true;
      try {
        const questionId = this.editingQuestion.id as number;
        const results = this.groupResultList
          .filter(item => item.resultCode || item.resultName)
          .map((item, index) => ({
            ...item,
            questionId,
            groupId: this.groupForm.id || null,
            sort: index + 1
          }));
        const res = await saveQuestionGroupDetail({
          group: { ...this.groupForm, questionId },
          itemIds: this.selectedGroupItemIds,
          results
        });
        if (res.success) {
          this.$message.success("保存成功");
          this.groupFormDialog = false;
          await this.loadGroups();
        } else {
          this.showApiError(res, "保存失败");
        }
      } finally {
        this.submitLoading = false;
      }
    });
  }

  public deleteGroupRow(row: QuestionGroupForm) {
    (this as any).$messageBox.confirm(`确定删除分组【${row.groupName}】吗？`, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      const res = await deleteQuestionGroup(row.id as number);
      if (res.success) {
        this.$message.success("删除成功");
        if (this.selectedGroupId === row.id) {
          this.selectedGroupId = null;
        }
        await this.loadGroups();
      } else {
        this.showApiError(res, "删除失败");
      }
    });
  }

  public addResultRow() {
    this.groupResultList.push({
      ...this.emptyResultForm(),
      sort: this.groupResultList.length + 1
    });
  }

  public deleteResultRow(index: number) {
    this.groupResultList.splice(index, 1);
    if (this.groupResultList.length === 0) {
      this.groupResultList.push(this.emptyResultForm());
    }
    this.groupResultList = this.groupResultList.map((item, sort) => ({
      ...item,
      sort: sort + 1
    }));
  }

  private async loadGroupItemIds(groupId: number) {
    const res = await getQuestionGroupItemList({ current: 1, size: 500, groupId });
    if (res.success) {
      this.selectedGroupItemIds = ((res.data && res.data.records) || [])
        .map((item: QuestionGroupItemForm) => item.itemId)
        .filter((itemId: number | null) => itemId !== null) as number[];
    }
  }

  private async loadGroupResults(groupId: number) {
    const res = await getQuestionResultList({ current: 1, size: 500, groupId });
    if (res.success) {
      const records = (res.data && res.data.records) || [];
      this.groupResultList = records.length > 0
        ? records
        : [this.emptyResultForm()];
    }
  }

  public async loadRules() {
    if (!this.editingQuestion.id) {
      return;
    }
    this.ruleLoading = true;
    try {
      const res = await getQuestionRuleList({ current: 1, size: 500, questionId: this.editingQuestion.id });
      if (res.success) {
        this.ruleList = (res.data && res.data.records) || [];
      }
    } finally {
      this.ruleLoading = false;
    }
  }

  public addRuleRow() {
    this.isAddRule = true;
    this.ruleForm = this.emptyRuleForm();
    this.ruleFormDialog = true;
  }

  public editRuleRow(row: QuestionRuleForm) {
    this.isAddRule = false;
    this.ruleForm = {
      ...this.emptyRuleForm(),
      ...row,
      sourceType: row.sourceType === "item" ? "inside" : row.sourceType || "inside",
      status: row.status === 0 ? 0 : 1
    };
    this.ruleFormDialog = true;
  }

  public submitRule(formRef: any) {
    formRef.validate(async (valid: boolean) => {
      if (!valid || !this.editingQuestion.id) {
        return;
      }
      if (this.needRuleCompareValue() && !this.ruleForm.optionId && !this.ruleForm.compareValue) {
        this.$message.warning("请配置触发选项或触发值");
        return;
      }
      this.submitLoading = true;
      try {
        const isExternal = this.ruleForm.sourceType === "external";
        const data = {
          ...this.ruleForm,
          questionId: this.editingQuestion.id,
          sourceType: this.ruleForm.sourceType || "inside",
          sourceField: isExternal ? this.ruleForm.sourceField : "",
          itemId: isExternal ? null : this.ruleForm.itemId,
          optionId: !isExternal && this.needRuleCompareValue() ? this.ruleForm.optionId || null : null,
          compareValue: this.needRuleCompareValue() && (!this.ruleForm.optionId || isExternal) ? this.ruleForm.compareValue : ""
        };
        const res = this.isAddRule ? await addQuestionRule(data) : await updateQuestionRule(data);
        if (res.success) {
          this.$message.success("保存成功");
          this.ruleFormDialog = false;
          await this.loadRules();
        } else {
          this.showApiError(res, "保存失败");
        }
      } finally {
        this.submitLoading = false;
      }
    });
  }

  public copyRuleRow(row: QuestionRuleForm) {
    (this as any).$messageBox.confirm("确定复制该规则吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      const res = await copyQuestionRule(row.id as number);
      if (res.success) {
        this.$message.success("复制成功");
        await this.loadRules();
      } else {
        this.showApiError(res, "复制失败");
      }
    });
  }

  public deleteRuleRow(row: QuestionRuleForm) {
    (this as any).$messageBox.confirm("确定删除该规则吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      const res = await deleteQuestionRule(row.id as number);
      if (res.success) {
        this.$message.success("删除成功");
        await this.loadRules();
      } else {
        this.showApiError(res, "删除失败");
      }
    });
  }

  public handleRuleItemChange() {
    this.ruleForm.optionId = null;
    this.ruleForm.compareValue = "";
    if (this.ruleForm.targetItemId === this.ruleForm.itemId) {
      this.ruleForm.targetItemId = null;
    }
  }

  public handleRuleConditionsChange() {
    if (!this.needRuleCompareValue()) {
      this.ruleForm.optionId = null;
      this.ruleForm.compareValue = "";
    }
  }

  public handleRuleSourceChange() {
    this.ruleForm.itemId = null;
    this.ruleForm.optionId = null;
    this.ruleForm.compareValue = "";
    if (this.ruleForm.sourceType !== "external") {
      this.ruleForm.sourceField = "";
      this.ruleForm.conditions = "eq";
    } else {
      this.ruleForm.sourceField = this.ruleForm.sourceField || "gender";
      this.ruleForm.conditions = "eq";
    }
  }

  public handleRuleSourceFieldChange() {
    this.ruleForm.optionId = null;
    this.ruleForm.compareValue = "";
    this.ruleForm.conditions = "eq";
  }

  private needRuleCompareValue() {
    return ["eq", "ne", "contains", "not_contains", "in", "not_in", "gt", "gte", "lt", "lte", "between"].indexOf(this.ruleForm.conditions) > -1;
  }

  private showApiError(res: any, fallback: string) {
    this.showApiMessage(res, fallback, "error");
  }

  private showApiMessage(res: any, fallback: string, type: "error" | "warning" = "error") {
    if (res && res.__messageShown) {
      return;
    }
    this.$message[type]((res && res.msg) || fallback);
  }

  public notReady(name: string) {
    this.$message.info(`${name}后续单独开发`);
  }

  public handleSizeChange(size: number) {
    this.form.size = size;
    this.form.current = 1;
    this.getTableData();
  }

  public handleCurrentChange(current: number) {
    this.form.current = current;
    this.getTableData();
  }

  public clearItemValidate() {
    const formRef = this.$refs.itemForm as any;
    if (formRef) {
      formRef.clearValidate();
    }
  }

  private itemRules = {
    itemCode: [{ required: true, message: "请输入题目编码", trigger: "blur" }],
    itemTitle: [{ required: true, message: "请输入题目标题", trigger: "blur" }],
    itemType: [{ required: true, message: "请选择题目类型", trigger: "change" }]
  };
}
